import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwMetaDataListCardConfigData } from '@devwareapps/devware-cap';

import { AppMetaDataItemNames } from '../../../../../meta-data/app-meta-data.service';

@DwComponent<DwMetaDataListCardConfigData>({
  name: 'Marketplace-Empty-Card-Redesign',
  key: 'marketplaceEmptyCardRedesign',
  componentType: DwComponentType.card,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.Course,
  configData: {
  }
})
@Component({
  selector: 'app-marketplace-empty-card-redesign',
  templateUrl: './marketplace-empty-card-redesign.component.html',
  styleUrls: ['./marketplace-empty-card-redesign.component.scss']
})
export class MarketplaceEmptyCardRedesignComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }
}
